import React, { useState, useEffect } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Upload, UploadActionsLayout, UploadOnBeforeUploadEvent, } from "@progress/kendo-react-upload";
import { MachinePicturesApi } from "./api";

type handler = () => void;
interface settingsProps {
  visible: boolean;
  toggleVisible: handler;
  machineSerial: string;
}

const UploadDialog = (props: settingsProps) => {

    const [csrfToken, setCsrfToken] = useState<string | null>(null);
    const [actionsLayout, setActionsLayout] =
        React.useState<UploadActionsLayout>("end");

    const apiBase = process.env.REACT_APP_API_BASE_URL ?? "";
    useEffect(() => {
        const fetchToken = async () => {
            if (!props.visible) return;

            const token = await MachinePicturesApi.loadCsrfToken(); 
            setCsrfToken(token);
        };

        fetchToken();
    }, [props.visible]);



    if (!props.visible) return null;
    const onBeforeUpload = (event: UploadOnBeforeUploadEvent) => {
        event.headers = {
            ...(event.headers || {}),
            "X-CSRF-TOKEN": csrfToken,
        };
    
    };
    const getSerial = (s: any) => {
        if (s == "16.2-CG12121212") {
            return "neiltest"
        }
        else {
            return s
        }
    }
    return (
        <Dialog title={"Image Upload"} onClose={props.toggleVisible} width={600}>
            <div style={{ backgroundColor: "#fff", padding: "20px" }}>
                <div className="upload">
                    <Upload
                        autoUpload={false}
                        multiple={true}
                        actionsLayout={actionsLayout}
                        defaultFiles={[]}
                        withCredentials={true}
                        saveUrl={`${apiBase}/api/machine/uploadPictures?machineSerial=${encodeURIComponent(
                            getSerial(props.machineSerial)
                        )}`}
                        restrictions={{
                            allowedExtensions: [".jpg", ".jpeg", ".png"],
                            maxFileSize: 10 * 1024 * 1024,
                        }}
                        onBeforeUpload={onBeforeUpload}
                        onRemove={(e:any) => {
                           // e.preventDefault();
                        }}
                    />
                </div>
            </div>
            <DialogActionsBar>
                <button
                    className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                    onClick={props.toggleVisible}
                >
                    Close
                </button>
            </DialogActionsBar>
        </Dialog>
    );
};


export default UploadDialog;
